module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_detail') === -1 && _vm.$route.path.indexOf('_edit') === -1) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "标题"
    },
    model: {
      value: (_vm.params.title),
      callback: function($$v) {
        _vm.$set(_vm.params, "title", $$v)
      },
      expression: "params.title"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.titleSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-circle-plus-outline"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("新增合约厂家")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingList),
      expression: "loadingList"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "manufactor_name",
      "label": "厂家",
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "厂家标题",
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "long_title",
      "label": "合约标题",
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "绑定虚拟商品",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDialogGoods(scope.row.bind_goods)
            }
          }
        }, [_vm._v("查看商品")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动时间",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.long_begin_time) + "-" + _vm._s(scope.row.long_end_time) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.del(scope.row.id)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.pagers.total > 0) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.fetchParams.page,
      "page-sizes": [10, 20, 50, 100],
      "total": _vm.pagers.total,
      "page-size": _vm.fetchParams.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.fetchParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.fetchParams, "page", $event)
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加、编辑厂家合约",
      "width": "40%",
      "visible": _vm.memberTagDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.memberTagDialog = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "选择厂家"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请输入关键词",
        "remote-method": _vm.remoteMethod1,
        "loading": _vm.loading
      },
      model: {
        value: (_vm.form.manufactor),
        callback: function($$v) {
          _vm.$set(_vm.form, "manufactor", $$v)
        },
        expression: "form.manufactor"
      }
    }, _vm._l((_vm.manufactorList), function(item) {
      return _c('el-option', {
        key: item.manufactor_id,
        attrs: {
          "label": item.manufactor_name,
          "value": item
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "合约标题"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入合约标题"
      },
      model: {
        value: (_vm.form.title),
        callback: function($$v) {
          _vm.$set(_vm.form, "title", $$v)
        },
        expression: "form.title"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "绑定对应商品"
      }
    }, [(_vm.form.goods_info != undefined && _vm.form.goods_info != '') ? _c('div', {
      staticClass: "goods",
      staticStyle: {
        "width": "400px"
      }
    }, [_c('div', {
      staticClass: "goods-thumbnail"
    }, [_c('img', {
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "src": _vm.form.goods_info.pics,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "goods-caption"
    }, [_c('div', {
      staticClass: "goods-title"
    }, [_vm._v("\n                " + _vm._s(_vm.form.goods_info.itemName) + "\n                "), (_vm.form.goods_info.special_type == 'drug') ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("处方药")]) : _c('span', {
      staticStyle: {
        "color": "blue"
      }
    }, [_vm._v("非处方药")]), _vm._v(" "), _c('span', {
      staticClass: "goods-remove iconfont icon-trash-alt",
      on: {
        "click": function($event) {
          return _vm.handleSkuRemove()
        }
      }
    })])])]) : _c('div', [_c('SkuSelector', {
      attrs: {
        "data": _vm.relItems
      },
      on: {
        "change": _vm.getItems
      }
    })], 1)]), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "必得优惠券"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择优惠券",
        "filterable": ""
      },
      on: {
        "change": function($event) {
          return _vm.changeCard()
        }
      },
      model: {
        value: (_vm.coupon_title),
        callback: function($$v) {
          _vm.coupon_title = $$v
        },
        expression: "coupon_title"
      }
    }, _vm._l((_vm.cardList), function(v, i) {
      return _c('el-option', {
        key: v.card_id,
        attrs: {
          "label": v.title,
          "value": v.card_id
        }
      })
    }), 1)], 1), _vm._v(" "), (_vm.form.is_must != 1) ? _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "支持多选"
      }
    }, [_c('el-radio-group', {
      attrs: {
        "size": "mini"
      },
      model: {
        value: (_vm.form.is_check),
        callback: function($$v) {
          _vm.$set(_vm.form, "is_check", $$v)
        },
        expression: "form.is_check"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": 0,
        "border": ""
      }
    }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 1,
        "border": ""
      }
    }, [_vm._v("是")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "选择合约"
      }
    }, [_c('el-select', {
      attrs: {
        "multiple": "",
        "filterable": "",
        "remote": "",
        "reserve-keyword": "",
        "placeholder": "请输入关键词",
        "remote-method": _vm.remoteMethod,
        "loading": _vm.loading
      },
      model: {
        value: (_vm.form.long_ids),
        callback: function($$v) {
          _vm.$set(_vm.form, "long_ids", $$v)
        },
        expression: "form.long_ids"
      }
    }, _vm._l((_vm.longList), function(item) {
      return _c('el-option', {
        key: item.goods_id,
        attrs: {
          "label": item.title,
          "value": item.goods_id
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.onSubmit
      }
    }, [_vm._v("确定保存")])], 1)], 1)]
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.goodsDialog.goodsVisible,
      "before-close": _vm.handleGoodsDialogCancel
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.goodsDialog, "goodsVisible", $event)
      }
    }
  }, [_c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.goodsDialog.dialogLoading),
      expression: "goodsDialog.dialogLoading"
    }],
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "md": 23
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.goodsList,
      "tooltip-effect": "dark"
    }
  }, [(false) ? _c('el-table-column', {
    attrs: {
      "prop": "item_id",
      "label": "商品id"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_name",
      "label": "商品名称",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          staticClass: "btn-gap",
          attrs: {
            "to": {
              path: _vm.matchInternalRoute('goodsphysical_editor') + '/' + scope.row.item_id
            }
          }
        }, [_vm._v(_vm._s(scope.row.item_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "商品编号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }]
        }, [_vm._v("商品id:" + _vm._s(scope.row.item_id))]), _vm._v(_vm._s(scope.row.item_bn))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "brief",
      "label": "商品简介",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "销售价格"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "market_price",
      "label": "市场价格"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_record",
      "label": "商品图片",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "right",
            "width": "240",
            "trigger": "hover"
          }
        }, [_c('div', {
          staticStyle: {
            "overflow-y": "scroll",
            "overflow-x": "hidden",
            "height": "240px",
            "text-align": "center"
          }
        }, _vm._l((scope.row.pics), function(v) {
          return _c('img', {
            staticClass: "goods-popover-img",
            staticStyle: {
              "width": "92%"
            },
            attrs: {
              "src": v
            }
          })
        }), 0), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "text"
          },
          slot: "reference"
        }, [_c('img', {
          attrs: {
            "src": "/static/img/icon_img.png"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4b51dd7a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b51dd7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/long/manufactor.vue
// module id = 2689
// module chunks = 0